import { FC, ReactNode } from "react";
import clsx from "clsx";

import "./Flex.scss";

export interface FlexContainerProps {
  children: ReactNode;
  container?: boolean;
  gap?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  marginLeft?: 1 | 2;
  marginBottom?: 1 | 2;
  marginTop?: 1 | 2;
  flexBasis?: string;
  justifyContent?: "space-between" | "space-around" | "flex-end" | "flex-start" | "center";
  flexDirection?: "column" | "row" | "row-reverse" | "column-reverse";
  alignItems?: "center" | "flex-end" | "flex-start";
  flexWrap?: "wrap";
}

export const Flex: FC<FlexContainerProps> = ({
  children,
  container,
  flexBasis,
  justifyContent,
  flexDirection,
  gap,
  alignItems,
  flexWrap,
  marginLeft,
  marginBottom,
  marginTop,
}) => {
  const flexBasisStyle = flexBasis ? { flexBasis, minWidth: flexBasis } : {};

  return (
    <div
      className={clsx({
        flex: container,
        [`${flexDirection}`]: flexDirection,
        [`${flexWrap}`]: flexWrap,
        [`jc-${justifyContent}`]: justifyContent,
        [`ai-${alignItems}`]: alignItems,
        [`gap-${gap}`]: gap,
        [`ml-${marginLeft}`]: marginLeft,
        [`mb-${marginBottom}`]: marginBottom,
        [`mt-${marginTop}`]: marginTop,
      })}
      style={{ ...flexBasisStyle }}
    >
      {children}
    </div>
  );
};
